var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      staticClass: "browse-form u-clearfix",
      attrs: { id: "browse-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return ((event) => _vm.submitHandler(event, _vm.submit)).apply(
            null,
            arguments
          )
        },
      },
    },
    [
      _vm.mode === "default"
        ? _c("h3", { staticClass: "browse-form__header" }, [
            _vm._v("Browse for a code"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("SelectTag", {
        staticClass: "browse-form__select browse-form__industry",
        attrs: {
          value: _vm.industry,
          options: _vm.industryOptions,
          loading: _vm.industryLoading,
          change: _vm.industryChange,
          placeholder: "Select your industry",
          name: "industry",
        },
      }),
      _vm._v(" "),
      _c("SelectTag", {
        staticClass: "browse-form__select browse-form__sector",
        attrs: {
          value: _vm.sector,
          options: _vm.sectorOptions,
          loading: _vm.sectorLoading,
          change: _vm.sectorChange,
          placeholder: "Select your sector",
          name: "sector",
        },
      }),
      _vm._v(" "),
      _c("SelectTag", {
        staticClass: "browse-form__select browse-form__category",
        attrs: {
          value: _vm.category,
          options: _vm.categoryOptions,
          loading: _vm.categoryLoading,
          change: _vm.categoryChange,
          placeholder: "Select your category",
          name: "category",
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "browse-form__button u-pull-right",
          attrs: {
            type: "submit",
            form: "browse-form",
            disabled: !_vm.category,
            "data-gtm-category": "Browse",
            "data-gtm-action": "Submit",
            "data-gtm-label": _vm.label,
          },
        },
        [_vm._v("Go")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "browse-form u-clearfix" }),
      _vm._v(" "),
      _vm.mode === "browse" && !_vm.nbResults
        ? _c("div", { staticClass: "browse-form_help" }, [
            _vm.routeName === "division" || _vm.routeName === "industry"
              ? _c("div", { staticClass: "help" }, [
                  _c("p", [
                    _vm._v(
                      "Starting with the suggested selection/s above, continue to make selections based on the goods or services your business produces or sells. \n        If you are self-employed, make selections based on what you do."
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.routeName !== "division" && _vm.routeName !== "industry"
              ? _c("div", { staticClass: "help" }, [
                  _c("p", [
                    _vm._v(
                      "Select your industry. For example, if you are a builder, select ‘construction’ and then make selections based on the goods or services your business produces or sells."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "If you are self-employed, make selections based on what you do."
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _vm._v("Need help? Read more about "),
      _c("a", { attrs: { href: "/help/" } }, [_vm._v("BIC codes →")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }